import { AccountUser, PageableResponse } from '../models';
import { composeQuery, Query } from '../models/query';
import { k1Axios } from './axios';

export const getAccountUsers = async (...criteria: Query<AccountUser>[]) => (
  await k1Axios.get<PageableResponse<AccountUser>>('/account-users', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<AccountUser>(...criteria),
    data: {},
  })
).data;
